import styled from '@emotion/styled/macro';

export const AssetEventsWrapper = styled.div``;